import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggleAnimation(event) {
    const progressBar = event.currentTarget.closest(".preview")?.querySelector(".progress-bar")
    progressBar?.classList.toggle("progress-bar-animated")
  }
}
